import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-30/task-01";

const task: Slide = {
  title: "Which icon represents a 9.1.0 system?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
